import { useMemo } from "react";
import { ChristmasLogoGif, CincoDeMayoGif, CrmLogo, CrmLogo4thJuly, CrmLogoChristmas, CrmLogoHalloween, EasterLogoGif, ThanksgivingLogoGif } from "../../icons";
import { isIn4thOfJulyRange, isInChristmasRange, isInCincoDeMayoRange, isInEasterRange, isInHalloweenRange, isInSnowyChristmasRange, isInThanksgivingRange } from "../../utils";

const Snowflakes = ({ count = 75 }) => {
    const getRandom = (max: number, min = 0) => Math.random() * (max - min) + min;

    return (
        <div className="overflow-hidden bg-transparent">
            {Array.from({ length: count }).map((_, i) => {
                const size = `${getRandom(1, 0.2).toFixed(2)}vw`;
                const left = `${getRandom(100).toFixed(2)}vw`;
                const animationDuration = `${(8 + getRandom(10)).toFixed(2)}s`;
                const animationDelay = `${(-getRandom(10)).toFixed(2)}s`;

                return (
                    <div
                        key={i}
                        className="absolute bg-white rounded-full"
                        style={{
                            width: size,
                            height: size,
                            left,
                            animation: `snowfall ${animationDuration} linear infinite`,
                            animationDelay,
                        }}
                    ></div>
                );
            })}
            <style>
                {`
          @keyframes snowfall {
            0% {
              transform: translateY(-5000%);
            }
            100% {
              transform: translateY(5000%);
            }
          }
        `}
            </style>
        </div>
    );
};

export const IconLoader = ({ color }: { color?: 'text-color1' | 'text-color7-contrast' }) => {
    const Logo = useMemo(() => {
        if (isInChristmasRange(new Date())) return <img src={ChristmasLogoGif} className="" alt="Christmas Logo" />
        if (isIn4thOfJulyRange(new Date())) return <CrmLogo4thJuly className="size-full" />
        if (isInHalloweenRange(new Date())) return <CrmLogoHalloween className="size-full" />
        if (isInThanksgivingRange(new Date())) return <img src={ThanksgivingLogoGif} className="" alt="Thanksgiving Logo" />
        if (isInCincoDeMayoRange(new Date())) return <img src={CincoDeMayoGif} className="" alt="Cinco de Mayo Logo" />
        if (isInEasterRange(new Date())) return <img src={EasterLogoGif} className="" alt="Easter Logo" />
        return <CrmLogo className={`fill-current !${color || 'text-color1'} transition-all size-full`} />;
    }, [color]);

    const hasAnimation = useMemo(() => {
        if (isInThanksgivingRange(new Date())) return false;
        if (isInChristmasRange(new Date())) return false;
        if (isInCincoDeMayoRange(new Date())) return false;
        if (isInEasterRange(new Date())) return false;
        return true;
    }, []);

    const showChristmasLoader = useMemo(() => {
        return isInSnowyChristmasRange(new Date());
    }, []);

    return (
        <>
            <div className="relative">
                <div className={hasAnimation ? "opacity-20" : ""}>{Logo}</div>
                {hasAnimation && (
                    <div className="absolute top-0 left-0 animate-loading-icon overflow-hidden size-full">
                        {Logo}
                    </div>
                )}
            </div>
            <div className="absolute top-0 left-0 z-10 flex min-h-screen size-full items-center justify-center overflow-hidden bg-influentia-black">
                {showChristmasLoader && <Snowflakes />}
            </div>
        </>
    );
};
